module.exports = __webpack_public_path__ + "static/media/background.9a00d0bf.png";